import { Component } from '@angular/core';

@Component({
  selector: 'lib-building',
  imports: [],
  templateUrl: './building.html',
  styles: ``,
})
export class Building {}
